module.exports = __webpack_public_path__ + "static/city-of-melbourne-logo-large-c950164844e1bae6d4eb3c8533a8e421.png";